export default {
  getCompanySkus: state => state.items
}



// WEBPACK FOOTER //
// ./src/store/modules/company_skus/getters.js